import { ChannelkartNetworkGet,ChannelkartNetworkPut } from "../../services/networkService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { DateRange, PjpPlanConfigType, DeviationDayCardType } from "./DeviationApprovalTypes";
import { getMetaDataConfig } from "../../services/uiConfigService";

  
  const getStartAndEndDate = (): DateRange => {
    const now = new Date();
  
    const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  
    const getFormattedDate = (date: Date, format: string): string => {
      const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
      return format
        .replace("yyyy", date.getFullYear().toString())
        .replace("MM", pad(date.getMonth() + 1))
        .replace("dd", pad(date.getDate()))
        .replace("HH", pad(date.getHours()))
        .replace("mm", pad(date.getMinutes()))
        .replace("ss", pad(date.getSeconds()));
    };
  
    const formattedStartDate = getFormattedDate(startDate, "yyyy-MM-dd HH:mm:ss");
    const formattedEndDate = getFormattedDate(endDate, "yyyy-MM-dd HH:mm:ss");
  
    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  };


export const getDeviationData = async (PjpPlanOption : any ) => {
    try {
        const dateRange = getStartAndEndDate();
        const { startDate, endDate } = dateRange;
        let status : string = "Pending";
        status = (PjpPlanOption?.appApprovalPlan === "1" || PjpPlanOption?.appApprovalPlan === "5") ? "Pending" : "DSEApproved,Pending&operator=in";
        const authContext = localStorage.getItem("authContext");
        const loginId = authContext ? JSON.parse(authContext).user.loginId : null;
        const approvedBy = PjpPlanOption?.deviationApprovalConfig?.deviationApprovalCheck == false ? "" : `&approvedBy=${loginId}`;
        const response = await ChannelkartNetworkGet(`/v1/deliveryPJP/PJPDeviation?startDate=${startDate}&endDate=${endDate}&status=${status}${approvedBy}&rate=true`);
        if (response.status === 200 || response.status === 201) {
          const PjpData = response.data.features;
        
          return PjpData;
        }
        else {
            return [];
        }
  
    } catch (error) {
      console.error("Error fetching Deviation data:", error);
      return [];
    }
  };


export const PjpPlanConfig = async () : Promise<PjpPlanConfigType | undefined> => {

    const localStorageValue = localStorage.getItem("authContext");
    let role: string = "";
    if (localStorageValue !== null) {
      role = JSON.parse(localStorageValue).user?.designation?.[0];
    }
 
    try {
      const clientConfig = await getMetaDataConfig(
        "clientconfig",
        `${role}_app_options_configuration`
      );
      const portalConfig = await getMetaDataConfig(
        "clientconfig",
        "portal_configuration"
      );
      const deviationApproval = portalConfig?.domainValues?.find(
        (config: any) => config.name === "deviationApproval"
      );

      const PjpPlanOptionConfig = clientConfig?.domainValues?.find(
        (config: any) => config.name === "pjpPlanOptions"
      );
      const appApprovalPlan = clientConfig?.domainValues?.find(
        (config: any) => config.name === "appApprovalPlan"
      );

      return {
        deviationApprovalConfig: deviationApproval?.value,
        appApprovalPlan: appApprovalPlan?.value,
        PjpPlanOptionConfig : PjpPlanOptionConfig?.value
      }

    } catch (e) {
      console.log("Error fetching PjpPlanOptionConfig", e);
    }
}



  export const convertDateToDDMMYYYY = (dateStr: string): string => {
    if (!dateStr) {
      return dateStr;
    }
    // Handle YYYY-MM-DD format (e.g., "2026-01-06")
    if (dateStr.includes('-')) {
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
        return `${day}-${month}-${year}`;
      }
    }
    // Handle YYYYMMDD format (e.g., "20260106") - fallback for backward compatibility
    if (dateStr.length === 8 && !dateStr.includes('-')) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${day}-${month}-${year}`;
    }
    return dateStr;
  };

export const transformDeviationDayCard = (
    deviationData: any,
    PjpPlanConfig: any
  ): DeviationDayCardType[] => {
    return deviationData.map((pjp: any) => {
      
      const extendedAttributes = JSON.parse(pjp.extended_attributes || "{}");
  
      const date = extendedAttributes.date || '';
      const PJPPlan = extendedAttributes.PJPPlan || '';
      const visitPlan = extendedAttributes.visitPlan || ''; 
      const beat = extendedAttributes.beatName || '';
  
      const startTown = extendedAttributes.fromTownName || '';
      const workTown = extendedAttributes.toTownName || '';
      const nhTown = extendedAttributes.NHTownName || '';
      const meetingTown = extendedAttributes.meetingTownName || '';
      const nhExist = pjp.NHExist || extendedAttributes?.NHExist || '';
      const routeCodeValid = pjp.routeCodeValid || extendedAttributes?.routeCodeValid || '';
      const routeCodeNHValid = pjp.routeCodeNHValid || extendedAttributes?.routeCodeNHValid || '';
      const statusRemarks = extendedAttributes.statusRemarks || '';
      const routeCodeNH = extendedAttributes.routeCodeNH || '';
      const routeCode = extendedAttributes.routeCode || '';
      const status = extendedAttributes.status || '';
      const userName = pjp.name || '';
      const dbName = extendedAttributes.dbName || '';
      const deviationId = pjp.id || '';
      const designation = extendedAttributes.designation || '';
      const loginId = pjp.loginid || '';
      const toTownName= extendedAttributes.toTownName || '';
      const toTownCode= extendedAttributes.toTownCode || '';
      const fromTownName=extendedAttributes.fromTownName || '';
      const fromTownCode= extendedAttributes.fromTownCode || '';
      const nhTownCode=extendedAttributes.NHTownCode || '';
      const nhTownName= extendedAttributes.NHTownName || '';
      const meetingTownCode=extendedAttributes.meetingTownCode  ||'';
      const meetingTownName= extendedAttributes.meetingTownName || '';
      const newTown= extendedAttributes.newTown || '';
      const previousBeatCode = pjp.previous_beat || '';
      const previousBeatName = pjp.previous_beat_name || '';
      const requestedBeatCode = pjp.beat || '';
      const requestedBeatName = pjp.beatName || '';
      const pjpDate = extendedAttributes.pjpDate || '';
  
      const matchingConfig = PjpPlanConfig.PjpPlanOptionConfig?.find(
        (config: any) => config.label.toUpperCase() === PJPPlan.toUpperCase()
      );
  
      const bgColor = matchingConfig?.bgColor || "#ffffff"; 
      const textColor = matchingConfig?.textColor || "#000000";
  
      return {
        date,
        PJPPlan,
        visitPlan,
        beat,
        bgColor,
        textColor,
        startTown,
        workTown,
        nhTown,
        meetingTown,
        nhExist,
        routeCodeValid,
        routeCodeNHValid,
        statusRemarks,
        routeCodeNH,
        routeCode,
        status,
        userName,
        dbName,
        deviationId,
        designation,
        loginId,
        toTownCode,
        fromTownName,
        fromTownCode,
        nhTownCode,
        nhTownName,
        meetingTownCode,
        meetingTownName,
        newTown,
        toTownName,
        previousBeatCode,
        previousBeatName,
        requestedBeatCode,
        requestedBeatName,
        pjpDate
      };
    });
  };

export async function submitDeviationApprovalData(
  deviationData: DeviationDayCardType,
  managerRemarks: string,
  PjpPlanConfig: any,
  action: 'approve' | 'reject',
): Promise<string> {
  const localStorageValue = localStorage.getItem("authContext");
  let role: string = "";
  let immediateParent: string = "";

  if (localStorageValue !== null) {
    const authContext = JSON.parse(localStorageValue);
    role = authContext.user?.designation?.[0] || "";
    immediateParent = authContext.user?.immediateParent || "";
  }
  
  let status = "approved";
  if (action === 'approve') {
    if (PjpPlanConfig.appApprovalPlan === "1") {
      status = "DSEApproved";
    }
  
    if (role === "bsm" && status === "DSEApproved") {
      status = "approved";
    }

  } else {
    status= "rejected"
  }
 

  const pjpDeviationRequestBody = {
    status,
    deviationApproverId: (PjpPlanConfig?.deviationApprovalConfig?.deviationApprovalCheck == false) ? "admin" : (immediateParent || ""),
    statusRemarks: managerRemarks,
    id: deviationData.deviationId,
    pjpDate:deviationData.date.length > 0 ? deviationData.date.split("-").reverse().join("-") : deviationData.pjpDate
  };

  try {
     if (status.toLowerCase() === "approved") {
      await autoChangeNextDatePJP(deviationData, status);
      const res = await ChannelkartNetworkPut(
        "/v1/pjpVisitPlan",
        pjpDeviationRequestBody
      );
      if (res.status === 200 || res.status === 201) {
        return "";
      } else {
        return "failed";
      }
    }
    else {
      const res = await ChannelkartNetworkPut(
        "/v1/pjpVisitPlan",
        pjpDeviationRequestBody
      );

      if (res.status === 200 || res.status === 201) {
        return "";
      } else {
        return "failed";
      }
    }

    
  } catch (error) {
    console.error("Error during PJP approval submission:", error);
    return "failed";
  }
}

export async function autoChangeNextDatePJP(
  deviationData: DeviationDayCardType,
  status : string
): Promise<string> {

  let successMsg : string = "";

  try {

  const visitDate = deviationData.date.split("-").reverse().join("-");
  const LastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0];

  if (status.toLowerCase() === "approved" && LastDay !== visitDate && 
        (deviationData.designation.toLowerCase() === 'ssr' ||
          deviationData.designation.toLowerCase() === 'psr')) {
            const dateObj = new Date(visitDate);
            dateObj.setDate(dateObj.getDate() + 1);
            const nextDate = dateObj.toISOString().split('T')[0];          
            const features =  await getNextDatePJP(deviationData.loginId, nextDate);

            if(features.length > 0) {
              let extendedAttributes = JSON.parse(features[0].extended_attributes || "{}");
            let pjpChanged : Boolean = false;
          if (deviationData.nhTownCode !== extendedAttributes["fromTownCode"] &&
            extendedAttributes["fromTownName"] !== "" &&
            extendedAttributes["fromTownName"].includes("Previous")){
          if (deviationData.nhTownCode !== "") {
            extendedAttributes["fromTownName"] = `Previous-${deviationData.nhTownName}`;
            extendedAttributes["fromTownCode"] = deviationData.fromTownCode;
            pjpChanged = true;
          } else if (features[0].hqCode !== "") {
            extendedAttributes["fromTownName"] = `HQ-${features[0].hqName}`;
            extendedAttributes["fromTownCode"] = features[0].hqCode;
            pjpChanged = true;
          } else {
            openPopup(
              "Alert",
              "HQ Town not available on this user!",
              () => {}
            );
          }

          if (pjpChanged) {
            extendedAttributes = routeCodeGenDevApp(extendedAttributes);
            successMsg = await submitPjpDeviationDataAsm(extendedAttributes, deviationData.loginId);
          }
        } else {
          successMsg = "";
        }
      } else {
        successMsg = "";
      }
    }
    return successMsg;
  } catch (e) {
    return "";
  }
            
}




export async function getNextDatePJP(loginId: string,nextDate : string): Promise<any[]> {
  try {
  const res = await ChannelkartNetworkGet(
    `/v1/query/getUserPJPWithHQTown?loginid=${loginId}&pjpdate=${nextDate}`);
if (res.status === 200 || res.status === 201) {
  return res.data['features'];
} else {
  return [];
}
} catch (e) {
return [];
}
}


function routeCodeGenDevApp(data: { [key: string]: any }): { [key: string]: any } {
  if (
    data["PJPPlan"] === "MARKET WORK" &&
    data["toTownCode"] !== "New Town" &&
    data["fromTownCode"] !== "New Town" &&
    data["fromTownCode"] !== null &&
    data["toTownCode"] !== null
  ) {
    data["routeCode"] = `${data["fromTownCode"]}_${data["toTownCode"]}`;
    data["routeName"] = `${data["fromTownName"]}_${data["toTownName"]}`;
  } else if (
    data["PJPPlan"] === "MEETING" &&
    data["fromTownCode"] !== "New Town" &&
    data["fromTownCode"] !== null &&
    data["meetingTownCode"] !== null
  ) {
    data["routeCode"] = `${data["fromTownCode"]}_${data["meetingTownCode"]}`;
    data["routeName"] = `${data["fromTownName"]}_${data["meetingTownName"]}`;
  }

  if (
    data["PJPPlan"] === "MARKET WORK" &&
    data["toTownCode"] !== null &&
    data["toTownCode"] !== "New Town" &&
    data["NHTownCode"] !== null
  ) {
    data["routeCodeNH"] = `${data["toTownCode"]}_${data["NHTownCode"]}`;
    data["routeNameNH"] = `${data["toTownName"]}_${data["NHTownName"]}`;
  } else if (
    data["PJPPlan"] === "MARKET WORK" &&
    data["fromTownCode"] !== null &&
    data["fromTownCode"] !== "New Town" &&
    data["NHTownCode"] !== null
  ) {
    data["routeCodeNH"] = `${data["fromTownCode"]}_${data["NHTownCode"]}`;
    data["routeNameNH"] = `${data["fromTownName"]}_${data["NHTownName"]}`;
  } else if (
    data["PJPPlan"] === "MEETING" &&
    data["meetingTownCode"] !== null &&
    data["NHTownCode"] !== null
  ) {
    data["routeCodeNH"] = `${data["meetingTownCode"]}_${data["NHTownCode"]}`;
    data["routeNameNH"] = `${data["meetingTownName"]}_${data["NHTownName"]}`;
  } else if (
    data["PJPPlan"] === "IN TRANSIT" &&
    data["fromTownCode"] !== "New Town" &&
    data["fromTownCode"] !== null &&
    data["NHTownCode"] !== null
  ) {
    data["routeCodeNH"] = `${data["fromTownCode"]}_${data["NHTownCode"]}`;
    data["routeNameNH"] = `${data["fromTownName"]}_${data["NHTownName"]}`;
  }

  return data;
}


export async function submitPjpDeviationDataAsm(extendedAttr : any,loginId: string): Promise<string> {
  try {
    const deviationPjpList = [
      {
        loginId: loginId,
        pjpDate: extendedAttr.date.split("-").reverse().join("-"),
        extendedAttributes: extendedAttr
      }
    ];

    const finalObj = {
      features: deviationPjpList
    };

    const res = await ChannelkartNetworkPut("/v1/deliveryPJP/batch",finalObj);
    if (res.status === 200 || res.status === 201) {
      return '';
    } else {
      return "failed";
    }
  } catch (e) {
    return "failed";
  }
}

